export default {
    setDriverPlanner (state, driverPlanner) {
        state.driverPlanner = driverPlanner
    },

}
